import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Features from './components/Features';
import Carousel from './components/Carousel';
import Media from './components/Media';
import Cards from './components/Cards';
import AppEntry from './components/AppEntry';
import Comments from './components/Comments';
import FAQ from './components/FAQ';
import About from './components/About';
import Topics from './components/Topics';
import Index from './components/Index';
import Updates from './components/Updates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Contact />
        <Features />
        <Carousel />
        <Media />
        <Cards />
        <AppEntry />
        <Comments />
        <FAQ />
        <About />
        <Topics />
        <Index />
        <Updates />
      </main>
      <Footer />
    </div>
  );
}